import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {ProductionSurplusItem, ProductionSurplusParams} from '../models/ProductionSurplus'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/visak-proizvodnje`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAll(params: ProductionSurplusParams) {
    return await axios.get<Array<ProductionSurplusItem>>(API, {headers: headers, params: params})
}

export async function get(id: number): Promise<ProductionSurplusItem> {
    const response = await axios.get(`${API}/${id}`, {headers: headers})
    return response.data?.data ?? response.data
}

export async function writeOff(id: number, napomena: string) {
    const response = await axios.patch(`${API}/${id}/otpisi`, {napomena}, {headers: headers})
    return response.data
}
